import { Component } from '@angular/core';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { AuthService } from '@core';
import { TokenData } from '@core/models/user';
import { debounceTime, delay } from 'rxjs';

@Component({
  selector: 'app-sso-callback',
  standalone: true,
  imports: [],
  templateUrl: './sso-callback.component.html',
  styleUrl: './sso-callback.component.scss'
})
export class SsoCallbackComponent {
  /**
   *
   */
  loading:boolean=false
  isFailed:boolean=false
  constructor(private authService:AuthService, private router:Router,    private route: ActivatedRoute) {
   
  }

  ngOnInit(): void {

    
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.loading=true
      // this.authService.validateRedirectedToken().subscribe({
      //   next: (isValid) => {
      //     console.log('Token validation successful:', isValid);
      //     // this.router.navigateByUrl('/dashboard');
      //     this.loading=false
      //     // Redirect to dashboard or secure area
      //   },
      //   error: (error) => {
      //     console.warn('Token validation failed:', error.message);
      //   }
      // });
    
      const urlParams = new URLSearchParams(window.location.search);
      const authCode = urlParams.get('code');
      const error = urlParams.get('error');
      if (error) {
        console.log('Error:', error);	
        
        this.authService.redirectToOtpSetup();
      }
      if (!authCode) {
        console.warn('No authorization code found.');
        return;
      }

     
    
      console.log(authCode, 'authCode received');
    
      setTimeout(() => {
        this.authService.exchangeCodeForToken(authCode)
        .subscribe({
          next: (res) => {
            console.log('Token successfully exchanged:', res);
            setTimeout(() => {
              this.router.navigateByUrl('/dashboard');
            }, 2000);
          },
          error: (err) => {
            this.isFailed=true
            console.error('Token exchange failed:', err);
            // window.location.href = "/";
            // this.router.navigate(['/login']); 
            
          }
        });
      }, 3000);
  }
}
